/**
 * @zh 逻辑直接从 message-text.vue copy 过来
 */
export const extractAndMergeContent = (str: string, botName: string): string[] => {
    const NEWLINE_MARKER = '__NEWLINE__';
    if (!str) return [];

    // 先替换掉 {{user}} 的内容及其后面的逗号
    str = str.replace(/\{\{user\}\},?/g, '');

    // 替换 {{char}} 为 'bot name'
    str = str.replace(/\{\{char\}\}/g, botName || '');

    // 分步骤处理换行符
    str = str
        // 处理双反斜杠换行
        .replace(/\\\\n/g, NEWLINE_MARKER)
        // 处理连续两个换行
        .replace(/\n\n/g, NEWLINE_MARKER)
        // 处理单个换行
        .replace(/\\n/g, NEWLINE_MARKER)
        // 处理剩余的换行
        .replace(/\n/g, NEWLINE_MARKER);

    const result: string[] = [];

    // 先按换行符分割
    const segments = str.split(NEWLINE_MARKER);

    segments.forEach((segment, index) => {
        if (segment.trim()) {
            // 处理每个非空段落中的其他格式
            const regex = /"(.*?\*.*?\*.*?)"|\*([^*]*)\*|\\'([^']*)\\'|\\"([^"]*)\\"|\s+|([^*"'\\]+)/g;

            const matches = segment.match(regex);
            if (matches) {
                matches.forEach(match => {
                    // 处理双引号中的星号内容
                    if (match.startsWith('"') && match.endsWith('"')) {
                        const asteriskMatch = match.match(/\*(.*?)\*/);
                        if (asteriskMatch) {
                            const parts = match.split(/\*(.*?)\*/);
                            parts.forEach((part, i) => {
                                if (i % 2 === 0) {
                                    // 非星号部分，去掉首尾引号
                                    const cleanPart = part.replace(/^"|"$/g, '').trim();
                                    if (cleanPart) result.push(cleanPart);
                                } else {
                                    // 星号部分
                                    result.push(`(${part})`);
                                }
                            });
                        } else {
                            // 没有星号的双引号内容
                            result.push(match.slice(1, -1));
                        }
                    } else if (match.startsWith('*') && match.endsWith('*')) {
                        // 处理星号内容
                        result.push(`(${match.slice(1, -1)})`);
                    } else if (match.startsWith("\\'") && match.endsWith("\\'")) {
                        // 处理转义单引号内容
                        result.push(match.slice(2, -2));
                    } else if (match.startsWith('\\"') && match.endsWith('\\"')) {
                        // 处理转义双引号内容
                        result.push(match.slice(2, -2));
                    } else if (match.trim()) {
                        // 处理普通文本
                        result.push(match.trim());
                    }
                });
            }
        }

        // 在非最后一个段落后添加换行标记
        if (index < segments.length - 1) {
            result.push(NEWLINE_MARKER);
        }
    });

    // 清理结果数组
    return result.filter(item => item && item.trim() && item !== NEWLINE_MARKER);
};

/**
 * @zh 逻辑直接从 message-text.vue copy 过来
 */
export const processMsgTextArray = (arr: string[]): string => {
    return arr
        .filter(item => !/^\(.*\)$/.test(item)) // 先过滤掉整个被括号包住的元素
        .map(item => item.replace(/\(.*?\)/g, '')) // 再去除每个元素内被括号包住的部分
        .filter(item => item.trim() !== '') // 过滤掉空字符串
        .join(' '); // 用空格拼接剩余的字符串
};
